import { Box, Button, Card, CardActions, CardContent, CardHeader, Container, makeStyles, Typography } from '@material-ui/core';
import { openChatState, SUPPORT_CHAT } from 'pages/CustomerBooking';
import { AppPopup } from 'pages/CustomerBooking/AppPopup';
import { Chat } from 'pages/CustomerBooking/Chat';
import { HeaderPillow } from 'pages/CustomerBooking/HeaderPillow';
import React, { useEffect, useMemo, useState } from 'react';
import ReactJson from 'react-json-view';
import Lottie from 'react-lottie-player';
import { Redirect, useHistory } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { useUserState } from 'services/authentication.service';
import animationData from 'src/assets/warning.json';
import { useTrackEvent } from 'util/trackEvent';
const useStyles = makeStyles((theme) => {
  return {
    lottie: {
      maxWidth: 100
    },
    errorCard: {

    },
    actions: {
      paddingBottom: theme.spacing(5),
      justifyContent: 'center',
      [theme.breakpoints.down("sm")]: {
        paddingBottom: theme.spacing(2),
      },
    },
    header: {
      alignSelf: "center",
    },
    cardContainer: {
      marginTop: theme.spacing(5),
    }
  }
})
const BookingError = ({ match, location }) => {
  const classes = useStyles()
  const validationState = location?.state
  const serviceId = match?.params?.serviceId
  const history = useHistory();
  const setChatOpen = useSetRecoilState(openChatState);
  const { getIdentity, user, getUser, logout } = useUserState()

  const trackEvent = useTrackEvent()

  if (!validationState) {
    return <Redirect to={{
      ...history.location,
      pathname:`/bookings/login/${serviceId}`
    }} />
  }
  return (
    <><Chat disableMedical serviceId={serviceId} source="Whitelabel"/>
      <AppPopup />
      <Container maxWidth="xs" disableGutters className={classes.errorCard}>
        <div className={classes.header}>
          <HeaderPillow />
        </div>
        <div className={classes.centerCard}>
          <Card className={classes.cardContainer}>
            <CardContent>
              <Lottie
                className={classes.lottie}
                play
                loop={0}
                animationData={animationData}
              />
              <CardHeader title="Booking Error" />
            </CardContent>
            <CardContent>
              {validationState.error?.details}
            </CardContent>
            <CardActions className={classes.actions}>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  trackEvent('Booking error - Contact Support - click', { 'type': SUPPORT_CHAT })
                  setChatOpen(SUPPORT_CHAT)
                }}
              >
                Contact Support
              </Button>
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  trackEvent('Booking error - Logout - click', { })
                  logout(serviceId, {})
                }}
              >
                logout
              </Button>

            </CardActions>

          </Card>
        </div>

      </Container>

    </>
  )
}

export { BookingError }